import { tw } from "@noones/ui/tw";
import React, { ReactNode } from "react";
import { FormattedNumber } from "react-intl";

export const Statistics = ({ data, description }: { data?: number; description: ReactNode }) => {
    if (!data) {
        return null;
    }

    return (
        <div className={tw.flex.rounded_lg.bg_white.flex_col.gap_1.p_4}>
            <div className={tw.text_h2.font_semibold}>
                <FormattedNumber value={data} />
            </div>
            <div className={tw.text_body_16.font_normal.text_grey_green}>{description}</div>
        </div>
    );
};
